import { TranslocoService, getBrowserLang } from '@ngneat/transloco';

// set fallback language before the browser try to load a not provided language
export function getLanguage() {
  return ['de', 'en'].find((language) => language === getBrowserLang()) ? getBrowserLang() : 'de';
}

export function initializeTranslations(transloco: TranslocoService) {
  return () => {
    const activeLanguage = getLanguage();
    transloco.setActiveLang(activeLanguage);
    return transloco.load(activeLanguage).toPromise();
  };
}
